<template> 
  <b-container class="clientes_services">   
    <Services :cliente="cliente"/>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Services from '@/components/Clientes/Services.vue' 

export default {
  name: 'clientes_services',
  props: {
  	cliente: {
      type: String,
      required: true,
    }
  },
  components: {
    Services, 
  }
}
</script>